'use client';
import { Link, Outlet } from 'react-router-dom';

import { HomeIcon, MenuItem, UnOrderListIcon } from '@/components';
import { usePathname } from '@/hooks';

const MenuItems = [
  {
    icon: <HomeIcon />,
    title: 'Personal Setting',
    path: 'personal-settings'
  },
  {
    icon: <UnOrderListIcon />,
    title: 'Saved Contacts',
    path: 'contacts'
  }
];

export default function MainLayout() {
  const pathname = usePathname() as string;

  return (
    <div className="bg-white flex h-full">
      <div className="w-[250px] flex-[0_0_250px] border-r border-gray-200 py-[32px] px-[8px]">
        {MenuItems.map((item, index) => (
          <Link to={item.path} key={index}>
            <MenuItem icon={item.icon} isActive={pathname?.endsWith(item.path)}>
              {item.title}
            </MenuItem>
          </Link>
        ))}
      </div>
      <div className="flex-1 overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
}
